import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const UserMailIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <path
      d="M3 2h16c1.1 0 2 .9 2 2v5h-2V6l-8 5-8-5v10h10v2H3c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2Zm0 2 8 5 8-5H3Z"
      clipRule="evenodd"
    />
    <path d="M18.5 16.5c1.5125 0 2.75-1.2375 2.75-2.75S20.0125 11 18.5 11s-2.75 1.2375-2.75 2.75 1.2375 2.75 2.75 2.75Zm5.5 4.7163c0-1.1138-.66-2.1038-1.6775-2.5438-1.1688-.5087-2.4613-.7975-3.8225-.7975-1.3612 0-2.6537.2888-3.8225.7975-1.0175.44-1.6775 1.43-1.6775 2.5438V22h11v-.7837Z" />
  </Icon>
);

export default memo(UserMailIcon);
